module.exports = __webpack_public_path__ + "img/upsell-intro-phones.b394904.png";